///
/// EarthBrowser
///
/// Created by Matt Giger on 10/14/2026
/// Copyright (c) 2026 Geodata Labs
///

import { RadarTextureFrame } from "@/earthbrowser/dataset-distribution/mrms/RadarTextureFrame"
import { type time, type timedelta } from "@stovokor/math/time"
import { type StovokorContext } from "@stovokor/StovokorContext"

/**
 * One hourly GMGSI cloud frame: a 4096x2048 single-channel "cold index"
 * texture (see weather-services process_cloud.py). Loaded as R8 with
 * mipmaps - at globe scale the texture is minified ~4x, and the cloud
 * field is high-frequency enough that plain linear minification shimmers
 * during animation. Wraps in longitude so flow-advected samples cross the
 * antimeridian cleanly.
 */
export class CloudTextureFrame extends RadarTextureFrame {
	constructor(context: StovokorContext, url: string, startTime: time, duration: timedelta) {
		super(context, url, startTime, duration, true)
		this.mipmaps = true
	}
}
